/* eslint-disable no-undef */
document.addEventListener('DOMContentLoaded', function() {
  /* */
  /* Format Input Currency START */
  const currencyInputsSet = document.querySelectorAll('.js-currency-input');
  const currency = 'AUD'; // https://www.currency-iso.org/dam/downloads/lists/list_one.xml
  if (currencyInputsSet) {
    currencyInputsSet.forEach(currencyInput => {
      // format inital value
      // onBlur({
      //   target: currencyInput
      // });

      // bind event listeners
      currencyInput.addEventListener('focus', onFocus);
      currencyInput.addEventListener('blur', onBlur);
    });
  }

  function localStringToNumber(s) {
    return Number(String(s).replace(/[^0-9.-]+/g, ""));
  }

  function onFocus(e) {
    const value = e.target.value;
    e.target.value = value ? localStringToNumber(value) : '';
  }

  function onBlur(e) {
    const target = e.target;
    let value = +e.target.value;

    if (value < target.dataset.min) {
      value = target.dataset.min;
    }

    const options = {
      maximumFractionDigits: 2,
      currency: currency,
      style: "currency",
      currencyDisplay: "symbol"
    }

    e.target.value = (value || value === 0) ?
      localStringToNumber(value).toLocaleString('en-AU', options) :
      ''
  }
  /* Format Input Currency END */
  /* */

  /* */
  /* Set contribution amount on radio buttons click START */
  const contributionRadiosSet = document.querySelectorAll('.js-contrib-radio');
  if (contributionRadiosSet) {
    const contributionInput = document.querySelector('.js-contrib-input');
    contributionRadiosSet.forEach(radio => {
      radio.addEventListener('change', () => {
        if (radio.checked) {
          contributionInput.value = radio.value;
          // Trigger 'blur' input
          const blurEvent = new Event('blur');
          contributionInput.dispatchEvent(blurEvent);
        }
      });
    });
    // Uncheck all radios on contributionInput change
    if (contributionInput) {
      contributionInput.addEventListener('change', () => {
        contributionRadiosSet.forEach(radio => {
          radio.checked = false;
        });
      });
    }
  }
  /* Set contribution amount on radio buttons click END */
  /* */
});
